import React from 'react';

import {connect} from 'react-redux';

import {useFeatureWithAnalytics} from 'components/feature';

import {ApplicationStoreType} from 'desktop/store';

import {getItemsCount, isFullLensesCart} from '../../store/selectors';
import {getSpecialOfferBanner} from '../../store/selectors/specialOffer/specialOffer';

import {CartSpecialOfferContent} from '../cartSpecialOffer/cartSpecialOffer';
import {CartSummaryConnected} from '../cartSummary/cartSummary';
import {CustomerService} from '../customerService/customerService';

import s from './cartSidebar.scss';

export type PropsType = {
    isFullLenses: boolean;
    specialOfferData: string;
    itemsCount: number;
};

/**
 * Сart right sidebar
 * @param {PropsType} props - props component
 * @returns {React.ReactElement} - Container component
 */
export const CartSidebar: React.FC<PropsType> = ({itemsCount, specialOfferData}) => {
    const isClRebate = useFeatureWithAnalytics('clRebate', false, 'desktop');

    return (
        <div className={s.sidebarWrapper}>
            <aside className={s.sidebar} data-test-name="mentionMeContainer" data-test-value="cart">
                {itemsCount !== 0 && (
                    <CartSpecialOfferContent specialOfferData={specialOfferData} />
                )}
                <CartSummaryConnected isClRebate={isClRebate} />
            </aside>
            <CustomerService />
        </div>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} state - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (state: ApplicationStoreType) => ({
    isFullLenses: isFullLensesCart(state),
    itemsCount: getItemsCount(state),
    specialOfferData: getSpecialOfferBanner(state),
});

export const CartSidebarConnected = connect(mapStateToProps)(CartSidebar);
